import { useCallback, useEffect, useState } from 'react';
import {
  estoqueApi,
  type EstoqueResumo,
  type MovimentacaoEstoqueResumo,
} from '@/features/estoque/api/estoqueApi';
import { useSyncReload } from '@/shared/hooks/useSyncReload';

type Estado = {
  itens: EstoqueResumo[];
  movimentacoes: MovimentacaoEstoqueResumo[];
  carregando: boolean;
  erro: string | null;
};

export function useEstoque() {
  const [estado, setEstado] = useState<Estado>({
    itens: [],
    movimentacoes: [],
    carregando: true,
    erro: null,
  });

  const recarregar = useCallback(async () => {
    setEstado((s) => ({ ...s, carregando: true, erro: null }));
    try {
      const [itens, movimentacoes] = await Promise.all([
        estoqueApi.listar(),
        estoqueApi.listarMovimentacoes(),
      ]);
      setEstado({ itens, movimentacoes, carregando: false, erro: null });
    } catch (e) {
      setEstado((s) => ({
        ...s,
        carregando: false,
        erro: e instanceof Error ? e.message : 'Falha ao carregar estoque.',
      }));
    }
  }, []);

  useEffect(() => {
    void recarregar();
  }, [recarregar]);

  useSyncReload(recarregar);

  return { ...estado, recarregar };
}
